let currentStore;

export const registerStore = (store) => {
    currentStore = store;
};

export const getStore = () => currentStore;